module.exports = "<div class=\"actor-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>"